import { CrossMarkSVG } from '@media/svgs/CrossMarkSVG'
import SuccessIcon from '@media/svgs/SuccessIcon'
import SpinningLoader from '@components/loaders/SpinningLoader'
import { BUY_BONUS_TEXTS, BUY_BONUS_MESSAGES } from '@constants/buyBonusConstants'
import { formatJackpotRatioText } from '@core/buyBonus/buyBonusView'

// Pure render — package list + select + Buy. All state (loading/empty/select)
// lives in useBuyBonusFlow; this component only receives and displays it.
const BuyBonusPackagesList = ({
  packages,
  currencyCode,
  selectedPackage,
  isLoading,
  isEmpty,
  onSelectPackage,
  onProceed,
  onClose,
}) => {
  const TEXTS = BUY_BONUS_TEXTS.PACKAGES_LIST

  return (
    <div className="standard-normal-buy-bonus-packages-list-outer-container">
      <div className="standard-normal-buy-bonus-packages-list-inner-container">
        <div className="standard-normal-buy-bonus-packages-list-close-container" onClick={onClose}>
          <CrossMarkSVG width="18px" height="18px" />
        </div>

        {isLoading ? (
          <div className="standard-normal-buy-bonus-packages-list-loader-container">
            <SpinningLoader />
          </div>
        ) : isEmpty ? (
          <div className="standard-normal-buy-bonus-packages-list-empty-container">
            {BUY_BONUS_MESSAGES.EMPTY_PACKAGES_LIST}
          </div>
        ) : (
          <>
            <div className="standard-normal-buy-bonus-packages-list-header-container">
              {TEXTS.PAGE_TITLE_LABEL}
            </div>

            <div className="standard-normal-buy-bonus-packages-list-body-container no-scrollbar">
              {packages.map((pkg) => {
                const isSelected = selectedPackage?.id === pkg.id

                return (
                  <div key={pkg.id} className="standard-normal-buy-bonus-package-item-container">
                    <div className="standard-normal-buy-bonus-package-title">{pkg.name}</div>
                    <div className="standard-normal-buy-bonus-package-details-container">
                      <div className="standard-normal-buy-bonus-package-details-count-container">
                        <div className="standard-normal-buy-bonus-package-details-label">
                          {TEXTS.NUMBER_OF_FREEBETS_LABEL}
                        </div>
                        <div className="standard-normal-buy-bonus-package-details-count-value">
                          <span className="standard-normal-buy-bonus-package-details-count-number">
                            {pkg.freebets}
                          </span>
                          <span className="standard-normal-buy-bonus-package-details-count-prefix">
                            {TEXTS.FREEBET_REWARD_PREFIX}
                          </span>
                        </div>
                      </div>

                      <div className="standard-normal-buy-bonus-package-details-amount-container">
                        <div className="standard-normal-buy-bonus-package-details-label">
                          {TEXTS.PACKAGE_AMOUNT_LABEL}
                        </div>
                        <div className="standard-normal-buy-bonus-package-details-amount-value">
                          {currencyCode} {pkg.packageValue}
                        </div>
                      </div>

                      <div className="standard-normal-buy-bonus-package-details-select-container">
                        <div
                          className={`standard-normal-buy-bonus-package-select-button ${isSelected ? 'selected' : ''}`}
                          onClick={() => onSelectPackage(pkg)}
                        >
                          {isSelected && <SuccessIcon size={12} />}
                        </div>
                      </div>
                    </div>

                    {Boolean(pkg.jackpotRatio) && (
                      <div className="standard-normal-buy-bonus-package-jackpot-ratio-container">
                        {formatJackpotRatioText(pkg.jackpotRatio)}
                      </div>
                    )}
                  </div>
                )
              })}
            </div>

            <div className="standard-normal-buy-bonus-packages-list-action-container">
              <button
                className={`standard-normal-buy-bonus-packages-list-action-button ${!selectedPackage ? 'disabled' : ''}`}
                onClick={onProceed}
                disabled={!selectedPackage}
              >
                {TEXTS.BUY_BUTTON_TEXT}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default BuyBonusPackagesList
